import { MouseEvent, useState } from 'react'
import { Printer } from 'lucide-react'

import { cn } from '@/lib/utils'

import { printStudyDoc } from './printStudyDoc'

export interface StudyDocPrintButtonProps {
  accessibleName: string
  testId?: string
  className?: string
}

const ICON_BUTTON_CLASS =
  'shrink-0 rounded p-1 text-muted-foreground transition-colors hover:bg-accent hover:text-accent-foreground disabled:opacity-50'

export function StudyDocPrintButton(props: StudyDocPrintButtonProps) {
  const {
    accessibleName,
    testId = 'artifact-chrome-print',
    className,
  } = props

  const [isPrinting, setIsPrinting] = useState(false)

  async function handleClick(event: MouseEvent<HTMLButtonElement>) {
    event.stopPropagation()
    if (isPrinting) {
      return
    }

    setIsPrinting(true)
    try {
      await printStudyDoc()
    } finally {
      setIsPrinting(false)
    }
  }

  return (
    <button
      type="button"
      className={cn(ICON_BUTTON_CLASS, className)}
      data-testid={testId}
      aria-label={`Print ${accessibleName}`}
      disabled={isPrinting}
      onClick={handleClick}
    >
      <Printer className="h-3.5 w-3.5" aria-hidden />
    </button>
  )
}
